import { useAddAccountStore, useGetDictionariesStore } from '@lib/store';
import { useAddCardStore } from '@lib/store/cards';
import { AddItemEnum } from '@shared/api/rest/models';
import { ButtonV2, ItemsType, Modal, Select } from '@shared/widgets';
import { Dispatch, useEffect, useState } from 'react';

interface AddAccountModalType {
  isOpen: boolean;
  onClose: Dispatch<React.SetStateAction<boolean>>;
  type: AddItemEnum;
}

export const AddNewItemModal = (props: AddAccountModalType) => {
  const dictionariesStore = useGetDictionariesStore();
  const addAccountStore = useAddAccountStore();
  const addCardStore = useAddCardStore();

  const [selectedCurrency, setSelectedCurrency] = useState<ItemsType>();

  useEffect(() => {
    if (dictionariesStore.data?.Currency && dictionariesStore.data.Currency.length > 0) {
      const allowedCurrencies =
        props.type === AddItemEnum.Card
          ? dictionariesStore.data.Currency.filter((c) => c.Name === 'USD' || c.Name === 'EUR')
          : dictionariesStore.data.Currency;

      const firstCurrency = allowedCurrencies[0];
      setSelectedCurrency({
        value: firstCurrency.Id,
        leftLabel: firstCurrency.Name,
      });
    }
  }, [dictionariesStore.data, props.type]);

  const handleCreateAccount = async () => {
    if (!selectedCurrency) return;

    try {
      if (props.type === AddItemEnum.Account) {
        await addAccountStore.create({ Currency: selectedCurrency.value });
      } else if (props.type === AddItemEnum.Card) {
        await addCardStore.add({ Currency: selectedCurrency.value });
      }
      props.onClose(false);
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  };

  const makeSelectData = () => {
    const currencies = dictionariesStore.data?.Currency || [];

    const allowedCurrencies = props.type === AddItemEnum.Card ? currencies.filter((c) => c.Name === 'USD' || c.Name === 'EUR') : currencies;

    return allowedCurrencies.map((item) => ({
      value: item.Id,
      leftLabel: item.Name,
    }));
  };

  const handleSelectCurrency = (value?: ItemsType) => {
    setSelectedCurrency(value);
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title={`Apply for a New ${props.type === AddItemEnum.Account ? 'Account' : 'Card'}`}>
      <div className='mt-2 w-full'>
        <div className='mb-7 text-center text-sm font-semibold text-[#666] uppercase'>Choose Currency</div>
        <Select value={selectedCurrency?.value} onChange={handleSelectCurrency} items={makeSelectData()} />
      </div>
      <div className='mt-4 flex w-full flex-col items-center justify-between gap-4'>
        <ButtonV2 color='primary' fullWidth onClick={handleCreateAccount}>
          Apply
        </ButtonV2>
        <ButtonV2 color='outlined' onClick={() => props.onClose(false)} fullWidth>
          Cancel
        </ButtonV2>
      </div>
    </Modal>
  );
};
